import React from 'react';
import PropTypes from 'prop-types';

import Header from '../../blocks/Header';
import ContactBanner from '../../blocks/ContactBanner';
import CompanyInfo from '../../blocks/CompanyInfo';
import ContactForm from '../../blocks/ContactForm';
import ProductsPresentation from '../../blocks/ProductsPresentation';
import Footer from '../../blocks/Footer';
import scrollToTopOrHash from '../../utils/helpers/scrollToTopOrHash';
import { sendPageView } from '../../utils/helpers/ga';

import phoneImage from './assets/phone.jpg';
import hostingSvg from '../../common/assets/icons/hosting.svg';
import websiteSvg from '../../common/assets/icons/website.svg';

class Contact extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      scrollToTopOrHash();
      window.document.title = 'Tag kontakt med oss - ScandGate AB';
      sendPageView(this.props.location.pathname);
    }
  }

  render() {
    return (
      <div>
        <Header currentLocation={this.props.location.pathname} />

        <ContactBanner
          background={phoneImage}
          headline="Vi hjälper dig gärna!"
          content={<p>Undrar du över våra tjänster? Eller behöver du hjälp med att komma igång?
            Oavsett behov så finns vi där för dig och löser det mesta.</p>}
          phone="+46101019720"
          email="info@scandgate.se"
        />

        <CompanyInfo
          headline="Kort om ScandGate AB"
          content={<p>ScandGate AB grundades 2012 med ett företagskoncept som gick ut på att
            fylla den behovslucka som tycks finnas mellan de IT-leverantörer som antingen erbjuder
            sina kunder en specialdesignad dyrare IT-lösning eller en gör-det-själv-lösning.
            Detta är lösningar som inte brukar passa de mindre företagen vidare väl där kanske varken
            större utvecklings-/driftbudgetar eller djupare IT-kunskaper finns att tillgå.<br /><br />

            Där kommer ScandGate in. Tack vare kostnadseffektiva lösningar kan vi erbjuda produktion,
            hosting samt intern eller extern support inom webbområdet som mindre företag har råd med och
            som heller inte är överdimensionerade i förhållande till företagets behov.<br /><br />

            I de fall vi stöter på kundbehov som ligger utanför vår baskompetens, löser vi även detta
            tack vare det kontaktnät ScandGate har tillgång till - oavsett om det gäller en specialdesignad
            webbplats eller en avancerad API-koppling till ett befintligt affärssystem. Ledorden för oss
            är att bygga djupgående kundrelationer och följa med våra kunder under hela resans gång.
            </p>}
          address={<div>
           Skolgången 17<br />
           802 57 Gävle<br />
          </div>}
          phoneLink="+46101019720"
          phone="+46 (0) 10 10 197 20"
          email="info@scandgate.se"
          organizationNumber="559084-8270"
        />

        <ContactForm
          darker
          headline="Kontakta ScandGate"
          content={<p>Vi svarar inom 24 timmar</p>}
          hostingPackages={{
            xxs: 'Upp till 10 användare',
            xs: 'Mellan 11 - 50 användare',
            s: 'Mellan 51 - 250 användare',
            l: 'Mellan 251 - 1000 användare',
            xl: 'Mellan 1001 - 2500 användare',
            xxl: 'Över 2500 användare',
          }}
          ctaText="Kontakta oss"
        />

        <ProductsPresentation
          headline="Våra tjänster"
          leftHeadline="1:st Line Support"
          leftUsps={[
              'Kompetent supportpersonal',
              'Integrerat ticketsystem',
              'Eget dedikerat 010-nummer',
              ]}
          leftIcon={hostingSvg}
          leftLink="/helpdesk/"
          rightHeadline="2:nd Line Support"
          rightUsps={[
              'Varierande programspråkskompetens',
              'Rapportering via Jira',
              'Kan samarbeta med er 3:rd Line Support',
              ]}
          rightIcon={websiteSvg}
          rightLink="/helpdesk#secondline"
        />

        <Footer />
      </div>
    );
  }
}

Contact.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./pages/Contact/index.js